























import {Watch, Component, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import SurveysTable from '@/components/lfs/Surveys/SurveysTable.vue'
import Toolbar from '@/components/lfs/Surveys/Toolbar.vue'

const surveys = namespace('surveys')

@Component({
  name: 'Surveys',
  components: {
    SurveysTable,
    Toolbar,
  }
})

export default class Surveys extends Vue {
  @surveys.Action('loadSurvey') protected loadSurvey:any
  @surveys.Action('createSurvey') protected createSurvey:any
  @surveys.Getter('survey') protected survey: any

  search:string = ''
  isShowArchive:boolean = false

  async addSurvey() {
    await this.createSurvey({title: this.$t('surveys.new')})
    this.$router.push(
      {
        name: 'Survey', params: {
          survey: this.survey.survey.id
        }
      }
    )
  }

  changeArchive() {
    this.isShowArchive = !this.isShowArchive
  }

  async copySurvey(item:any) {
    await this.loadSurvey(item.survey.id)
    let params = {
      title: this.$t('surveys.copy') + ' ' + this.survey.survey.title,
      questions: this.survey.survey.questions,
      hasSignature: this.survey.survey.hasSignature,
      isArchived: false,
      isActive: false,
      message: this.$t('surveys.alert.addCopy')
    }
    await this.createSurvey(params)
    this.$router.push(
      {
        name: 'Survey', params: {
          survey: this.survey.survey.id
        }
      }
    )
  }

  searchSurvey(search:string) {
    this.search = search
  }

  selectSurvey(item:any) {
    this.loadSurvey(item)
  }
}
